/**
 *
 * @type {{GREETING: string}}
 */
export const VIDEO_TYPE = {
  GREETING: 'GREETING',
};
